<span [ngSwitch]="status">
    <span class="badge badge-warning" *ngSwitchCase="'PENDING'">{{'transferStatusValue.PENDING' | translate}}</span>
    <span class="badge badge-primary" *ngSwitchCase="'IN_PROGRESS'">{{'transferStatusValue.IN_PROGRESS' | translate}}</span>
    <span class="badge badge-success" *ngSwitchCase="'COMPLETED'">{{'transferStatusValue.COMPLETED' | translate}}</span>
    <span class="badge badge-danger" *ngSwitchCase="'CANCELLED'">{{'transferStatusValue.CANCELLED' | translate}}</span>
    <span class="badge badge-info" *ngSwitchDefault>{{'transferStatusValue.' + status | translate}}</span>
</span>